<template>
    <el-dialog title="快速发货" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
               :close-on-press-escape="false" width="30%">
        <el-form size="small" ref="order" :model="order" label-width="100px">
          <el-form-item label="物流公司" prop="express_id" :rules="[{required: true,message: '请选择物流公司'}]">
            <el-select v-model="order.express_id" placeholder="请选择快递公司">
              <el-option :label="item.express_name" v-for="(item, index) in expressList" :key="index" :value="item.express_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物流单号" prop="express_no" :rules="[{required: true,message: '请填写物流单号'}]">
            <el-input v-model="order.express_no" class="max-w460"></el-input>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="submitFunc()" :loading="loading">发货</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import OrderApi from '@/api/order.js';
    import CustomizationApi from '@/api/customization.js';
    export default {
        data() {
            return {
                order_id: 0,
                loading: false,
                /*左边长度*/
                formLabelWidth: '100px',
                /*是否显示*/
                dialogVisible: true,
                /*表单*/
                order: {
                    express_id: null,
                    express_no: '',
                },
            };
        },
        props: ['expressList', 'detail'],
        created() {
            this.order.express_id = this.detail.express_id;
            this.order.express_no = this.detail.express_no;
        },
        methods: {
            /*确认事件*/
            submitFunc(e) {
                let self = this;
                self.$refs.order.validate((valid) =>
                {
                    if (valid) {
                        self.loading = true;
                        CustomizationApi.updateExpress({
                              order_id: this.detail.order_id,
                              order: this.order,
                            },
                            true
                          ).then(data =>
                        {
                            self.loading = false;
                            self.$message({
                                message: '恭喜你，发货成功',
                                type: 'success'
                            });
                            self.dialogFormVisible();
                        }).catch(error =>
                        {
                            self.loading = false;
                        });
                    }
                });
            },
            /*关闭弹窗*/
            dialogFormVisible() {
              this.$emit("close", { openDialog: false });
            },
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/customization/order/dialog/updateExpress.vue